module.exports = __webpack_public_path__ + "static/media/spaceArt.d7b7d911.jpg";